import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { baseActions } from "../../base/models/BaseSlice";
import useQuery from "../../base/utils/UseQuery";
import PPPProjectsTable from "../components/PPPProjectTable";

const PPPProjects = () => {
  const dispatch = useDispatch();
  const contentDivHeight = useSelector(
    (state: any) => state.base.contentDivHeight
  );
  const headerHeight = 0;
  const rowPadding = 12;
  const paperHeight = contentDivHeight - 2.5 * rowPadding - headerHeight - 5;

  React.useEffect(() => {
    dispatch(baseActions.setPaperHeight(paperHeight));
  }, [dispatch, paperHeight]);

  const query = useQuery();
  const qParams = ["donor", "region", "sro", "sector"];
  const params: any = {};
  qParams.forEach((name) => {
    params[name] = query.get(name) || "all";
  });

  // const [rows, setRows] = React.useState<Row[]>([]);
  // const [columns, setColumns] = React.useState<Column[]>([]);
  const [showGrid, setShowGrid] = React.useState(false);

  // React.useEffect(() => {
  //     if (rows.length === 0 && columns.length === 0) {
  //         const url: string = APIs.MoPD_PROJECT_INFORMATION;
  //         Api.get(url, params).then((payload) => {
  //             console.log("PSDP Projects Payload", payload)
  //             if (payload) {
  //                 setRows(payload.rows);
  //                 setColumns(payload.columns);
  //             }
  //         });
  //     }
  // }, [params, rows.length, columns.length]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <React.Fragment>
      {/*<div style={{ padding: "15px" }}>*/}
      {showGrid && <PPPProjectsTable />}
      {/*</div>*/}
    </React.Fragment>
  );
};

export default PPPProjects;
